import { toast } from "sonner";
import { useSavedChannelIds } from "@/hooks/useSavedChannels";

/**
 * Star button used on every leaderboard row to save / unsave a niche
 * (anchored on this specific channel). Optimistic — flips state instantly,
 * rolls back on API failure.
 */
export default function SaveNicheButton({ channel, source = "top_revenue" }) {
  const { ids, toggle } = useSavedChannelIds();
  const isSaved = ids.has(channel.channel_id);

  return (
    <button
      data-testid={`save-niche-btn-${channel.channel_id}`}
      data-saved={isSaved ? "true" : "false"}
      title={isSaved ? "Saved to your niches — click to remove" : "Save this niche"}
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          const nowSaved = await toggle({ ...channel, source });
          toast.success(
            nowSaved
              ? `Saved · ${channel.niche || channel.name}`
              : `Removed · ${channel.niche || channel.name}`,
          );
        } catch (err) {
          toast.error(err?.response?.data?.detail || "Couldn't save");
        }
      }}
      className={`font-mono text-[10px] uppercase tracking-[0.15em] px-2 py-1.5 rounded-sm transition-colors leading-tight border ${
        isSaved
          ? "bg-yellow-400 text-black border-yellow-400 hover:bg-yellow-300"
          : "text-yellow-400 border-yellow-400/40 hover:bg-yellow-400/10"
      }`}
    >
      {isSaved ? "★ Saved" : "☆ Save"}
    </button>
  );
}
